import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableFacebookFacelift = Loadable({
  loader: function loader() {
    return import('../FacebookFacelift.jsx');
  },
  loading: ComponentLoading
});
export default LoadableFacebookFacelift;